<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="success">
            <b-navbar-brand href="#"
                ><img src="/img/logo_navbar.png"
            /></b-navbar-brand>
        </b-navbar>
        <div class="container-fluid">
            <div class="row">
                <br />
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-9">
                    <b-nav tabs>
                        <b-nav-item active v-on:click="back"
                            ><h5 style="color:green">
                                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                                Retour
                            </h5></b-nav-item
                        >
                    </b-nav>
                    <b-card title="Card Title" no-body>
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-6">
                                    <b-button
                                        variant="outline-success"
                                        v-on:click="download"
                                        >Télécharger</b-button
                                    >
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <h1>CHARTE GRAPHIQUE</h1>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <h2>Mode été</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="row">
                                        <div class="col-lg-9">
                                            Principale
                                        </div>

                                        <div class="form__input col-lg-3">
                                            <v-swatches
                                                v-model="
                                                    currentProjet[0].primary
                                                "
                                                show-fallback
                                                fallback-input-type="color"
                                                popover-x="left"
                                                text-basic
                                                :trigger-style="{
                                                    width: '30px',
                                                    height: '30px'
                                                }"
                                            ></v-swatches>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3">
                                    <div class="row">
                                        <div class="col-lg-9">
                                            Secondaire
                                        </div>

                                        <div class="form__input col-lg-3">
                                            <v-swatches
                                                v-model="
                                                    currentProjet[0].secondary
                                                "
                                                show-fallback
                                                fallback-input-type="color"
                                                popover-x="left"
                                                text-basic
                                                :trigger-style="{
                                                    width: '30px',
                                                    height: '30px'
                                                }"
                                            ></v-swatches>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <h1>IMAGE ACCUEIL</h1>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="custom-file">
                                        <label
                                            class="btn btn-outline-success"
                                            for="imageLogo"
                                            >Choisir une image</label
                                        >
                                        <input
                                            class="custom-file-input outline-success"
                                            type="file"
                                            id="imageLogo"
                                            @change="imageLogo"
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <img
                                        id="previewLogo"
                                        class="imageLogoSize"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <h1>IMAGE HEADER</h1>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="custom-file">
                                        <label
                                            class="btn btn-outline-success"
                                            for="imageHeader"
                                            >Choisir une image</label
                                        >
                                        <input
                                            class="custom-file-input outline-success"
                                            type="file"
                                            id="imageHeader"
                                            @change="imageHeader"
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <img
                                        id="previewHeader"
                                        class="imageHeaderSize"
                                    />
                                </div>
                            </div>
                        </b-card-body>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import JSZip from "jszip";
import VSwatches from "vue-swatches";
import { saveAs } from "file-saver";
import axios from "axios";
import hexToRgba from "hex-to-rgba";
import _ from "lodash";
export default {
    data: function() {
        return {
            projetStyle: [],
            infos: "Lozère",
            menu: [],
            currentProjet: [],
            contentImageHeader: [],
            contentImageLogo: [],
            configPin: [],
            finalObject: []
        };
    },
    components: {
        VSwatches
    },
    async beforeMount() {
        console.log(hexToRgba("#F2C511"));
        this.menu = this.$route.params.menu;
        this.currentProjet.push(this.menu.menu_style);

        this.projetStyle.push({
            ref: "",
            KomuraMenu_header: "",
            KomuraMenu_headerHeight: "",
            Komura_logo: "",
            "KomuraMenu_home-icon": "",
            "KomuraMenu_home-color": "",
            "KomuraMenu_back-icon": "",
            "Komura_back-color": "",
            name: "",
            DepartementalMenu_logo: "",
            DepartementalMenu_header: "",
            DepartementalMenu_homeColorBg: "",
            DepartementalMenu_backColorbg: "",
            DepartementalMenu_mainColor: "",
            DepartementalMenu_secondaryColor: ""
        });
    },
    methods: {
        imageHeader: function(e) {
            this.currentProjet[0].imageHeader = e.target.files[0].name;
            this.contentImageHeaders = e.target.files[0];
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(evt) {
                document.getElementById("previewHeader").src =
                    evt.target.result;
            };
        },
        imageLogo: function(e) {
            this.currentProjet[0].imageLogo = e.target.files[0].name;
            this.contentImageLogo = e.target.files[0];
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(evt) {
                document.getElementById("previewLogo").src = evt.target.result;
            };
        },
        save: function() {
            let img = document.getElementById("previewHeader");
            this.currentProjet.imageHeight = img.height;

            this.projetStyle.splice(0, 1, {
                ref: "KomuraMenu",
                KomuraMenu_header:
                    "%URL%/images/" + this.currentProjet[0].imageHeader,
                KomuraMenu_headerHeight: this.currentProjet.imageHeight,
                KomuraMenu_logo:
                    "%URL%/images/" + this.currentProjet[0].imageLogo,
                KomuraMenu_partners: "",
                "KomuraMenu_home-color": this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                "KomuraMenu_back-color": this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                name: "DepartementalMenu",
                DepartementalMenu_logo:
                    "%URL%/images/" + this.currentProjet[0].imageLogo,
                DepartementalMenu_header:
                    "%URL%/images/" + this.currentProjet[0].imageHeader,
                DepartementalMenu_homeColorBg: this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                DepartementalMenu_backColorbg: this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                DepartementalMenu_mainColor: this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                DepartementalMenu_secondaryColor: this.transformColor(
                    hexToRgba(this.currentProjet[0].secondary, 255)
                )
            });
        },
        transformColor: function(color) {
            let matchColors = /rgba\((\d{1,4}), (\d{1,4}), (\d{1,4}), (\d{1,4})\)/;
            var match = matchColors.exec(color);
            let data = "";
            if (match != null) {
                data =
                    "(" +
                    match[1] +
                    "," +
                    match[2] +
                    "," +
                    match[3] +
                    "," +
                    match[4] +
                    ")";
            }
            return data;
        },
        pushMenu: function(menus) {
            menus.forEach(element => {
                this.finalObject.push({
                    ref: this.parseId(element.name, "style"),
                    "Fiche_bloc-color": this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    FirstMenu_background_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    IconMenuItem_iconColor: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    RandoMenuItem_altColor: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    SkiMenuItem_altBackground: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    SimpleBreadcrumb_background_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    IconBreadcrumb_iconColor: this.transformColor(
                        hexToRgba(element.frontcolor, 255)
                    ),
                    IconMenuItem_icon:
                        "%URL%/icones/icon_" + element.icon + ".png",
                    IconBreadcrumb_icon:
                        "%URL%/icones/icon_" + element.icon + ".png",
                    Point_poi:
                        "%URL%/icones/pin_" +
                        this.parseId(element.name, "style") +
                        ".png",
                    Point_poi_selected:
                        "%URL%/icones/pin_" +
                        this.parseId(element.name, "style") +
                        "_selected.png",
                    Track_mainColor: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    TabControl_selected_bgColor: this.transformColor(
                        hexToRgba(this.currentProjet[0].primary, 255)
                    ),
                    TabControl_bgColor: this.transformColor(
                        hexToRgba(this.currentProjet[0].primary, 255)
                    ),
                    DptFicheListItem_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    DptMenuListItem_backColor: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    DptMenuListItem_icon:
                        "%URL%/icones/icon_" + element.icon + ".png",
                    DptIconBreadcrumb_icon:
                        "%URL%/icones/icon_" + element.icon + ".png",
                    DptIconBreadcrumb_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    DptFicheList_Color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    DptFicheRando_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    ),
                    DptFicheRando_color2: this.transformColor(
                        hexToRgba(this.currentProjet[0].secondary, 255)
                    ),
                    DptFicheGoto_gotoColor: this.transformColor(
                        hexToRgba(this.currentProjet[0].primary, 255)
                    ),
                    DptFicheGoto_gotoColorSelected: this.transformColor(
                        hexToRgba(this.currentProjet[0].secondary, 255)
                    ),
                    DptFicheService_color: this.transformColor(
                        hexToRgba(element.iconcolor, 255)
                    )
                });
                if (element.icon != "") {
                    this.configPin.push({
                        name: element.icon,
                        menu: this.parseId(element.name, "style"),
                        color: element.iconcolor
                    });
                }
                this.pushMenu(element.children);
            });
        },
        download: async function() {
            this.save();
            this.finalObject = [];
            this.finalObject.push(this.projetStyle[0]);
            this.finalObject.push({
                ref: "ProfilElevation",
                "ProfilElevation_profil-line-color": this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                ),
                ProfilElevation_bottomColorA: this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 70)
                ),
                ProfilElevation_bottomColorB: this.transformColor(
                    hexToRgba(this.currentProjet[0].primary, 255)
                )
            });
            var zip = new JSZip();
            this.configPin = [];
            this.pushMenu(this.menu.list);
            zip.file("styles.json", JSON.stringify(this.finalObject));
            let images = zip.folder("images");
            let icon = zip.folder("icones");
            if (this.configPin.length != 0) {
                let response = await axios({
                    method: "post",
                    url: "https://mediaserver.kalkin-dev.fr/media/generate",
                    responseType: "arraybuffer",
                    data: {
                        config: this.configPin
                    }
                });
                if (response.data) {
                    let blob = new Blob([response.data], {
                        type: "application/zip"
                    });
                    icon.file("icone.zip", blob);
                }
            }
            images.file(
                this.currentProjet[0].imageHeader,
                this.contentImageHeaders
            );
            images.file(this.currentProjet[0].imageLogo, this.contentImageLogo);
            zip.generateAsync({ type: "blob" }).then(function(content) {
                saveAs(content, "data.zip");
            });
        },

        parseId: function(name, type) {
            let text = "";
            if (type == "id") {
                text = _.deburr(
                    _.words(_.toLower(name))
                        .reduce((acc, cur) => {
                            if (
                                cur.length >= 3 &&
                                cur !== "des" &&
                                cur !== "les"
                            ) {
                                acc.push(cur);
                            }
                            return acc;
                        }, [])
                        .join("_")
                );
            }
            if (type == "style") {
                text = _.deburr(
                    _.words(_.toLower(name))
                        .reduce((acc, cur) => {
                            if (
                                cur.length >= 3 &&
                                cur !== "des" &&
                                cur !== "les"
                            ) {
                                acc.push(cur);
                            }
                            return acc;
                        }, [])
                        .join("-")
                );
            }
            return text;
        },
        back: function() {
            this.$router.push({
                name: "HomeRetour",
                params: {
                    menu: this.menu
                }
            });
        }
    }
};
</script>
<style>
.imageHeaderSize {
    width: 500px;
    max-height: 380px;
}
.imageLogoSize {
    width: 500px;
    max-height: 250px;
}
</style>
